<div class="hint" [class.visible]="hintActive">
  <div class="hint__close" [class.visible]="hintActive">
    <mat-icon (click)="closeHint()">clear</mat-icon>
  </div>
  <div class="hint__content">
    <app-pwa-install *ngIf="hint === 'pwa-install'"></app-pwa-install>
  </div>
</div>
